import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYoutubestudioComponent } from './simple-icons-youtubestudio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYoutubestudioComponent ],
    exports:      [ SimpleIconsYoutubestudioComponent ],
    bootstrap:    []
})
export class SimpleIconsYoutubestudioModule {}
